import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-select_up",
  "use": "icon-select_up-usage",
  "viewBox": "0 0 1638 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1638 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-select_up\">\n  <path d=\"M1521.664 1024L1638.4 931.84 819.2 0 0 931.84 116.736 1024 819.2 225.28z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/svg/select_up.svg
// module id = LD1h
// module chunks = 1